import type { EnvironmentId } from "@t3tools/contracts";

interface CloudEnvironmentLike {
  readonly environmentId: EnvironmentId;
  readonly label: string;
  readonly serverConfig?: { readonly environment: { readonly placement?: string } } | null;
}

/**
 * The Cloud page always means the Cloud environment, so it derives its target
 * from the catalog instead of carrying a device picker. A missing placement
 * stays local: an older server must never become billable merely because a
 * client is new enough to know about Cloud.
 *
 * Cloud is a single-runtime MVP today; the sort only keeps the pick stable if
 * a second runtime ever shows up.
 */
export function selectCloudEnvironments<T extends CloudEnvironmentLike>(
  environments: ReadonlyArray<T>,
): ReadonlyArray<T> {
  return environments
    .filter((environment) => environment.serverConfig?.environment.placement === "cloud")
    .toSorted(
      (left, right) =>
        left.label.localeCompare(right.label) ||
        String(left.environmentId).localeCompare(String(right.environmentId)),
    );
}
